import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

jQuery(function ($) {
  // click image thumb product - single product
  const wpg__image = $(".wpg__image");
  wpg__image.find("a").on("click", function (e) {
    e.preventDefault();
    $(this).next(".image-popup").trigger("click");
  });
  const wpg__thumb = $(".wpg__thumb");
  wpg__thumb.find("a").on("click", function (e) {
    e.preventDefault();
  });
  // Cap nhat gio hang khi bam tang giam so luong
  if (!$("body").hasClass("woocommerce-cart")) return;
  let timeout;
  $(".woocommerce").on("change", "input.qty", function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      $("[name='update_cart']").prop("disabled", false).trigger("click");
      setTimeout(function () {
        window.location.reload();
      }, 600);
    }, 300);
  });
  // End Cap nhat gio hang khi bam tang giam so luong
});
// js button quantity
jQuery(document).ready(function () {
  jQuery(".quantity").on("click", ".plus", function (e) {
    var inputQty = jQuery(this).prev("input.qty");
    var val = parseInt(inputQty.val());
    inputQty.val(val + 1).change();
  });
  jQuery(".quantity").on("click", ".minus", function (e) {
    var inputQty = jQuery(this).next("input.qty");
    var val = parseInt(inputQty.val());
    if (val > 0) {
      inputQty.val(val - 1).change();
    }
  });
});
jQuery(document).ajaxComplete(function () {
  jQuery(".quantity")
    .off("click", ".plus")
    .on("click", ".plus", function (e) {
      var inputQty = jQuery(this).prev("input.qty");
      var val = parseInt(inputQty.val());
      inputQty.val(val + 1).change();
    });
  jQuery(".quantity")
    .off("click", ".minus")
    .on("click", ".minus", function (e) {
      var inputQty = jQuery(this).next("input.qty");
      var val = parseInt(inputQty.val());
      if (val > 1) {
        inputQty.val(val - 1).change();
      }
    });
});
jQuery(document).on("yith_wcan_ajax_filtered", function () {});
// change text btn filter plugin
jQuery(document).ready(function () {
  jQuery(".apply-filters").text("LỌC");
  jQuery("button.btn.btn-primary.yith-wcan-filters-opener").text("Lọc");
  jQuery(".apply-filters.main-modal-button").text("Hiển thị kết quả");
  jQuery(".filters-container .clear-selection").text("Xoá tất cả");
});
// xoa dau ngoc item-count
jQuery(document).ready(function ($) {
  function removeBrackets() {
    $(".item-count").each(function () {
      var $this = $(this);
      var text = $this.text();
      if (text.includes("(")) {
        $this.text(text.replace(/[()]/g, ""));
      }
    });
  }
  removeBrackets();
  $(document).on("yith_wcan_ajax_filtered yith_wcan_init", function () {
    removeBrackets();
  });
  var observer = new MutationObserver(function (mutations) {
    removeBrackets();
  });
  $(".yith-wcan-filters").each(function () {
    observer.observe(this, { childList: true, subtree: true });
  });

  // Truncate and toggle short description
  const shortDesc = $('.woocommerce-product-details__short-description');
  if (shortDesc.length) {
    if (shortDesc[0].scrollHeight > 100) {
      shortDesc.addClass('is-truncated');
      $('.scroll-to-desc-btn').show();
    } else {
      $('.scroll-to-desc-btn').hide();
    }
  }

  $('body').on('click', '.scroll-to-desc-btn', function (e) {
    e.preventDefault();
    const shortDesc = $('.woocommerce-product-details__short-description');
    if (shortDesc.hasClass('is-truncated')) {
      shortDesc.removeClass('is-truncated').addClass('is-expanded');
      $('.scroll-to-desc-btn').text('THU GỌN');
    } else {
      shortDesc.removeClass('is-expanded').addClass('is-truncated');
      $('.scroll-to-desc-btn').text('XEM THÊM');
      if (shortDesc.length) {
        $('html, body').animate({
          scrollTop: shortDesc.offset().top - 100
        }, 300);
      }
    }
  });

  // Truncate and toggle about product section description
  const aboutDesc = $('.about-product-desc-content');
  const aboutToggleBtn = $('#btnAboutToggle');
  
  if (aboutDesc.length && aboutToggleBtn.length) {
    if (aboutDesc[0].scrollHeight > 120) {
      aboutDesc.addClass('is-truncated');
      $('.about-product-desc-fade').show();
      aboutToggleBtn.show();
    } else {
      aboutDesc.removeClass('is-truncated');
      $('.about-product-desc-fade').hide();
      aboutToggleBtn.hide();
    }
  }

  $('body').on('click', '#btnAboutToggle', function (e) {
    e.preventDefault();
    const btn = $(this);
    const textMore = btn.data('more') || 'XEM THÊM';
    const textLess = btn.data('less') || 'RÚT GỌN';
    const aboutDesc = $('.about-product-desc-content');
    const fade = $('.about-product-desc-fade');

    if (aboutDesc.hasClass('is-truncated')) {
      aboutDesc.removeClass('is-truncated').addClass('is-expanded');
      btn.text(textLess);
      fade.hide();
    } else {
      aboutDesc.removeClass('is-expanded').addClass('is-truncated');
      btn.text(textMore);
      fade.show();
      const targetOffset = $('.product-about-section').offset().top - 100;
      $('html, body').animate({
        scrollTop: targetOffset > 0 ? targetOffset : 0
      }, 300);
    }
  });

  // Truncate and toggle story section left description
  const storyDesc = $('.story-left-desc-content');
  const storyToggleBtn = $('#btnStoryToggle');
  
  if (storyDesc.length && storyToggleBtn.length) {
    if (storyDesc[0].scrollHeight > 150) {
      storyDesc.addClass('is-truncated');
      $('.story-left-desc-fade').show();
      storyToggleBtn.show();
    } else {
      storyDesc.removeClass('is-truncated');
      $('.story-left-desc-fade').hide();
      storyToggleBtn.hide();
    }
  }

  $('body').on('click', '#btnStoryToggle', function (e) {
    e.preventDefault();
    const btn = $(this);
    const textMore = btn.data('more') || 'XEM THÊM';
    const textLess = btn.data('less') || 'RÚT GỌN';
    const storyDesc = $('.story-left-desc-content');
    const fade = $('.story-left-desc-fade');

    if (storyDesc.hasClass('is-truncated')) {
      storyDesc.removeClass('is-truncated').addClass('is-expanded');
      btn.text(textLess);
      fade.hide();
    } else {
      storyDesc.removeClass('is-expanded').addClass('is-truncated');
      btn.text(textMore);
      fade.show();
      const targetOffset = $('.product-story-section').offset().top - 100;
      $('html, body').animate({
        scrollTop: targetOffset > 0 ? targetOffset : 0
      }, 300);
    }
  });
});


